<div
  class="sidenav-container"
  [class.collapsed]="isNavCollapsed"
  [class.mobile-nav-open]="isMobileNavOpen"
>
  <div class="logo-container">
    <app-logo *ngIf="!isNavCollapsed"></app-logo>
    <img
      *ngIf="isNavCollapsed"
      src="/assets/images/sidebar/logo-small.svg"
      alt="Small Logo"
      class="small-logo"
    />
    <button class="close-menu-button" (click)="toggleCollapse()">
      <img
        [src]="
          isNavCollapsed
            ? '/assets/images/sidebar/chevron-right.svg'
            : '/assets/images/sidebar/chevron-left.svg'
        "
        alt="Toggle menu"
      />
    </button>
  </div>
  <div class="menu-container">
    <div class="menu-scrollable">
      <!-- Attendant Menu - full shop-floor navigation -->
      <div class="menu-section" *ngIf="isAttendant">
        <ul class="menu-items">
          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/attendance"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/attendance-icon.svg" alt="Attendance" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Attendance</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Attendance</span>
            </a>
          </li>

          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/sales"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/sales-icon.svg" alt="Sales" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Sales</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Sales</span>
            </a>
          </li>

          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/cash-reconciliation"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/currency-dollar.svg" alt="Cash Reconciliation" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Cash Reconciliation</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Cash Reconciliation</span>
            </a>
          </li>

          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/orders"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/orders-icon-new.svg" alt="Orders" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Orders</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Orders</span>
            </a>
          </li>

          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/appointments"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/appointments-icon-new.svg" alt="Appointments" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Appointments</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Appointments</span>
            </a>
          </li>

          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/rewards"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/rewards-icon.svg" alt="Rewards" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Rewards</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Rewards</span>
            </a>
          </li>

          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="hasPermission('canManageCustomers')"
          >
            <a
              routerLink="/customer"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/customers-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Customers</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Customers</span>
            </a>
          </li>

          <!-- <li class="menu-item" routerLinkActive="active">
                    <a routerLink="/camera" class="menu-link" (click)="onMenuLinkClick()" (mouseenter)="onMenuLinkMouseEnter($event)">
                        <span class="menu-icon">
                            <img src="/assets/images/sidebar/camera-icon.svg" alt="Camera">
                        </span>
                        <span class="menu-text" *ngIf="!isNavCollapsed">Camera</span>
                        <span class="menu-tooltip" *ngIf="isNavCollapsed">Camera</span>
                    </a>
                </li> -->

          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/profile"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/profile-icon.svg" alt="Profile" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Profile</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Profile</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Staff Menu - attendance + profile only -->
      <div class="menu-section" *ngIf="isStaff">
        <ul class="menu-items">
          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/attendance"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/attendance-icon.svg" alt="Attendance" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Attendance</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Attendance</span>
            </a>
          </li>
          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/profile"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/profile-icon.svg" alt="Profile" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Profile</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Profile</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Admin Menu - Original Complex Structure -->
      <div class="menu-section" *ngIf="isAdmin">
        <div class="menu-title-container">
          <span class="menu-title" *ngIf="!isNavCollapsed">TRACK</span>
          <span class="menu-title" *ngIf="isNavCollapsed">TR...</span>
        </div>
        <ul class="menu-items">
          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/dashboard"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/dashboard-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Dashboard</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Dashboard</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canViewAnalytics')"
          >
            <a
              routerLink="/analytics"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/analytics-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Analytics</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Analytics</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canViewReports')"
          >
            <a
              routerLink="/reports"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/reports-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Reports</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Reports</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canViewPayments')"
          >
            <a
              routerLink="/payments"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/currency-dollar.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Payments</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Payments</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canManagePackages')"
          >
            <a
              routerLink="/package"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/packages-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Packages</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Packages</span>
            </a>
          </li>
          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/orders"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/orders-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Orders</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Orders</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canManagePackages')"
          >
            <a
              routerLink="/discount"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/discount-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Discount</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Discount</span>
            </a>
          </li>
          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/appointments"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/appointments-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Appointments</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Appointments</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canManageCustomers')"
          >
            <a
              routerLink="/customer"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/customers-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Customers</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Customers</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="divider" *ngIf="isAdmin"></div>
      <div class="menu-section" *ngIf="isAdmin">
        <div class="menu-title-container">
          <span class="menu-title" *ngIf="!isNavCollapsed">OPERATIONS</span>
          <span class="menu-title" *ngIf="isNavCollapsed">OPS</span>
        </div>
        <ul class="menu-items">
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canViewCRM')"
          >
            <a
              routerLink="/campaign"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/crm-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Campaign Hub</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Campaign Hub</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="isAdmin || hasPermission('canManageFleet')"
          >
            <a
              routerLink="/fleet"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/fleet-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Fleet Management</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Fleet Management</span>
            </a>
          </li>
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="hasPermission('canManageEmployees')"
          >
            <a
              routerLink="/employee"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/employee-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Employee Tracking</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Employee Tracking</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="divider" *ngIf="isAdmin"></div>
      <div class="menu-section" *ngIf="isAdmin">
        <div class="menu-title-container">
          <span class="menu-title">OTHER</span>
        </div>
        <ul class="menu-items">
          <li class="menu-item" routerLinkActive="active">
            <a
              routerLink="/car-wash-website"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/website-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Car Wash Website</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Car Wash Website</span>
            </a>
          </li>
          <!-- <li class="menu-item" routerLinkActive="active">
                    <a routerLink="/camera" class="menu-link" (click)="onMenuLinkClick()" (mouseenter)="onMenuLinkMouseEnter($event)">
                        <span class="menu-icon">
                            <img src="/assets/images/sidebar/camera-icon.svg" alt="Camera">
                        </span>
                        <span class="menu-text" *ngIf="!isNavCollapsed">Camera</span>
                        <span class="menu-tooltip" *ngIf="isNavCollapsed">Camera</span>
                    </a>
                </li> -->
          <li
            class="menu-item"
            routerLinkActive="active"
            *ngIf="hasPermission('canManageSettings')"
          >
            <a
              routerLink="/settings"
              class="menu-link"
              (click)="onMenuLinkClick()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img src="/assets/images/sidebar/settings-icon.svg" alt="" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">Settings</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">Settings</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="divider mobile-view"></div>
    <!-- User Profile Section -->
    <a
      class="user-profile-section mobile-view"
      [routerLink]="isAdmin ? '/settings' : '/profile'"
      (click)="onMenuLinkClick()"
      style="text-decoration: none; cursor: pointer; display: block"
    >
      <div class="user-profile-content">
        <div class="user-info">
          <div class="user-avatar">
            <img
              *ngIf="hasProfileImage"
              [src]="getProfileImage()"
              [alt]="userName"
              class="avatar-image"
            />
            <div *ngIf="!hasProfileImage" class="avatar-initials">{{ initials }}</div>
          </div>
          <div class="user-details" *ngIf="!isNavCollapsed">
            <div class="user-name">{{ userName }}</div>
            <div class="user-role">{{ userRole }}</div>
          </div>
        </div>
        <!-- Decorative; parent <a> navigates to settings/profile -->
        <span class="edit-profile-btn" *ngIf="!isNavCollapsed" aria-hidden="true">
          <svg
            width="16"
            height="19"
            viewBox="0 0 16 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 16.5V14.8333C1 13.9493 1.35119 13.1014 1.97631 12.4763C2.60143 11.8512 3.44928 11.5 4.33333 11.5H7.25M2.66667 4.83333C2.66667 5.71739 3.01786 6.56524 3.64298 7.19036C4.2681 7.81548 5.11595 8.16667 6 8.16667C6.88406 8.16667 7.7319 7.81548 8.35702 7.19036C8.98214 6.56524 9.33333 5.71739 9.33333 4.83333C9.33333 3.94928 8.98214 3.10143 8.35702 2.47631C7.7319 1.85119 6.88406 1.5 6 1.5C5.11595 1.5 4.2681 1.85119 3.64298 2.47631C3.01786 3.10143 2.66667 3.94928 2.66667 4.83333ZM11.35 12.0083C11.5125 11.8458 11.7054 11.7169 11.9178 11.629C12.1301 11.541 12.3577 11.4957 12.5875 11.4957C12.8173 11.4957 13.0449 11.541 13.2572 11.629C13.4696 11.7169 13.6625 11.8458 13.825 12.0083C13.9875 12.1708 14.1164 12.3638 14.2044 12.5761C14.2923 12.7884 14.3376 13.016 14.3376 13.2458C14.3376 13.4757 14.2923 13.7032 14.2044 13.9156C14.1164 14.1279 13.9875 14.3208 13.825 14.4833L11 17.3333H8.5V14.8333L11.35 12.0083Z"
              stroke="#717683"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </div>
    </a>

    <!-- Logout Section -->
    <button class="logout-section mobile-view" (click)="onLogout()" aria-label="Logout">
      <div class="logout-content">
        <div class="logout-icon-container">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.83268 4.99967C4.82134 5.85365 4.09682 6.99776 3.75721 8.27712C3.41759 9.55648 3.47929 10.9093 3.93394 12.1524C4.38859 13.3956 5.21423 14.469 6.29911 15.2274C7.38398 15.9858 8.67568 16.3925 9.99935 16.3925C11.323 16.3925 12.6147 15.9858 13.6996 15.2274C14.7845 14.469 15.6101 13.3956 16.0648 12.1524C16.5194 10.9093 16.5811 9.55648 16.2415 8.27712C15.9019 6.99776 15.1774 5.85365 14.166 4.99967M9.99935 3.33301V9.99967"
              stroke="#DA1E28"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="logout-text-container" *ngIf="!isNavCollapsed">
          <span class="logout-text">Logout</span>
        </div>
      </div>
    </button>
  </div>
</div>
